import { createIcon } from '../createIcon';

export const VuejsIconConfig = {
  name: 'VuejsIcon',
  height: 512,
  width: 448,
  svgPath: 'M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const VuejsIcon = createIcon(VuejsIconConfig);

export default VuejsIcon;